module.exports = __webpack_public_path__ + "img/parkedinyard.e2019334.svg";